import { Component, inject, OnInit } from '@angular/core';
import { DestroyBase } from '../../../../shared/base-classes/destroy-component-base';
import { PublicLinkService } from '../../services/public-link.service';
import { combineLatest, switchMap, takeUntil } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-outreach-link-callback',
  standalone: true,
  imports: [],
  templateUrl: './outreach-link-callback.component.html',
  styleUrl: './outreach-link-callback.component.scss',
})
export class OutreachLinkCallbackComponent
  extends DestroyBase
  implements OnInit
{
  publicOutreachService = inject(PublicLinkService);
  route = inject(ActivatedRoute);
  router = inject(Router);

  ngOnInit(): void {
    combineLatest([this.route.paramMap, this.route.queryParamMap])
      .pipe(
        takeUntil(this.destroy$),
        switchMap(([params, queryParams]) => {
          const uuid = params.get('id') || '';
          const accessType = queryParams.get('access_type') || '';

          if (uuid && accessType) {
            return this.publicOutreachService.redirectPublicLink(
              uuid,
              accessType,
            );
          } else {
            return [];
          }
        }),
      )
      .subscribe({
        next: (redirectUrl) => {
          window.location.href = redirectUrl;
        },
        error: () => {
          this.router.navigate(['/error?code=404']);
        },
      });
  }
}
